var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-block"},[_c('div',{staticClass:"content-block__container"},[(_vm.newData.items.length)?_c('MultiRowsBlockList',_vm._b({attrs:{"items":_vm.newData.items,"data-test-id":"multi-rows-block-list"}},'MultiRowsBlockList',{ settings: _vm.settings },false)):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }